import { clearAuthUser, removeSessionId } from "../utils/auth-storage.js"
import { el, setChildren } from "redom"
import { isApp } from '../utils/app-type-checker.js'
import { hostAppCall } from "../utils/appFunctions.js"
import { mountLoginModal } from "./login.js"
import { Popover, Modal } from "bootstrap"
export const clearForSignIn = () => {
    clearAuthUser()
    displaySignInButtonOnTopMenu()
    // TODO: implement to notify the user to log in.
}
export const displaySignInButtonOnTopMenu = (): void => {
    const userLoginCol = document.getElementById("user-login-col")
    if (!userLoginCol) return
    setChildren(userLoginCol, // workaround for embed
        el("div", { className: "col-auto", align: "right", style: "padding: 14.5px 10px 14.5px 0px"},
            el("button", { className: "btn btn-outline-light btn-sm", id: "login", onclick: showSignIn, textContent: "Sign in"})
        )
    );
}

export const showSignIn = () => {
    removeSessionId()  // remove this if not needed.
    if(isApp()) hostAppCall("loginView")
    else {
        const loginModal = mountLoginModal()
        document.querySelectorAll('[data-bs-toggle="popover"]').forEach(el => Popover.getInstance(el)?.hide())
        Modal.getOrCreateInstance(loginModal).show();
    }
}
